import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
	Row,
	Button,
	InputGroup,
	InputGroupAddon,
	Label,
	Col,
	Input,
} from "reactstrap";
import CustomReactSelect from "../../../components/CustomReactSelect";
import "./SptimesheetStyle.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { UserConsumer } from "../../../UserContext";
import { Timesheet_APIs } from "./Timesheet_API";
import axios from "axios";
import * as Yup from "yup";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { Timesheet_Variables } from "./timesheet_Variables";
import Header from "./Header";

import { AlertPopups } from "../../../components/AlertPopups";
import { Redirect } from "react-router-dom";
import { Formik } from "formik";
let token = null;
const validate = Yup.object().shape({
	checkInTime: Yup.object().shape({
		hours: Yup.string().required("Required"),
	}),
	checkOutTime: Yup.object().shape({
		hours: Yup.string().required("Required"),
	}),
});
const timeOptions = [
	{ value: 0, label: "AM" },
	{ value: 1, label: "PM" },
];
const initialValues = {
	hours: "",
	minutes: "",
	time: { value: 0, label: "AM" },
};

class UpdateAttendance extends Component {
	constructor(props) {
		super(props);
		this.state = {
			offsiteRequestFormFields: initialValues,
			checkInTime: initialValues,
			checkOutTime: {
				hours: "",
				minutes: "",
				time: { value: 1, label: "PM" },
			},
			totalHoursThisWeek: 0,
			perdayHours: [],
			hoursPerProjectPerDay: [],
			employee: [],
			datePicker: new Date(),
			Comments: "",
			disabled: false,
			date: new Date(),
			employeeList: [],
			joiningDate: new Date(),
			noDataFlag: true,
			returnData: false,
			allProjects: [],
			noOfprojects: "",
			status: "",
			currentTimesheetDate: new Date(),
			weekDates: [],
			taskName: "",
			commentDate: "",
			empComments: "",
			CommentsErr: "",
			noRecord: false,
			showLoader: false,
			recordId: 0,
			checkintime: "",
			checkOuttime: "",
			isDisabled: true,
		};
	}

	componentDidMount() {
		this.getEmployeesList();
	}
	getEmployeesList = () => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(`${Timesheet_APIs.GetSupervisorEmployees_API}`, {
				headers: headers,
			})
			.then((res) => {
				this.setState({
					employeeList: res.data,
				});
			});
	};
	openDatepicker = () => this._calendar.setOpen(true);
	employees() {
		return this.state?.employeeList?.map((data) => ({
			label: data.name,
			value: data.employeeId,
		}));
	}

	handleChange = (temp, displayCode, event) => {
		this.setState({
			checkinTime: "",
			checkOuttime: "",
		});

		if (displayCode === 1) {
			//employee dropdown
			this.setState({
				[event.name]: temp,
				isDisabled: false,
				recordId: temp.value,
			});
		} else if (displayCode === 2) {
			//datePicker
			this.setState({
				datePicker: temp,
			});
		} else if (displayCode === 3) {
			let CommentsErr = this.state.CommentsErr;
			CommentsErr =
				temp.target.value.length > 500
					? "Max 500 characters allowed"
					: "";
			this.setState({
				//Supervisor Comments
				[temp.target.name]: temp.target.value,
				CommentsErr,
			});
		}
	};

	handleSubmit = () => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		const checkIn =
			this.state.checkInTime.hours +
			":" +
			this.state.checkInTime.minutes +
			" " +
			this.state.checkInTime.time.label;
		const checkOut =
			this.state.checkOutTime.hours +
			":" +
			this.state.checkOutTime.minutes +
			" " +
			this.state.checkOutTime.time.label;

		const data = {
			recordId: this.state.recordId,
			checkedInAt: moment(checkIn, "H:mm A").format("HH:mm:ss"),
			checkedOutAt: moment(checkOut, "H:mm A").format("HH:mm:ss"),
		};

		if (this.state.recordId === 0) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Select Employee",
			});
		} else if (this.state.checkOutTime.hours === "") {
			AlertPopups.ErrorAlert.fire({
				text: "Please enter checkOut time",
			});
		} else if (this.state.checkOutTime.minutes === "") {
			AlertPopups.ErrorAlert.fire({
				text: "Please enter CheckOut time",
			});
		} else {
			axios
				.put(`${Timesheet_APIs.GetCheckInOutTimeAPI}`, data, {
					headers: headers,
				})
				.then((res) => {
					AlertPopups.successAlert.fire({
						text: "CheckOut Time Updated",
					});

					this.handleReset();
				})
				.catch((error) => {
					if (error.response) {
						AlertPopups.ErrorAlert.fire({
							text: `${error.response.data.message}`,
						});
					}
				});
		}
	};
	handleClick = () => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(
				`${Timesheet_APIs.GetCheckInOutTimeAPI}?EmployeeId=${
					this.state.employee.value
				}&RecordDate=${moment(this.state.datePicker).format(
					"YYYY-MM-DD"
				)}`,
				{
					headers: headers,
				}
			)
			.then((res) => {
				if (res.data === "") {
					AlertPopups.successAlert.fire({
						text: `No record found`,
					});
					this.setState({
						checkInTime: {
							hours: "",
							minutes: "",
							time: { value: 0, label: "AM" },
						},
						checkOutTime: {
							hours: "",
							minutes: "",
							time: { value: 1, label: "PM" },
						},
						recordId: this.state.employee.value,
					});
				} else if (
					res.data.checkInTime === null &&
					res.data.checkOutTime === null &&
					res.data.recordId === null
				) {
					AlertPopups.successAlert.fire({
						text: `No record found`,
					});
					this.setState({
						checkInTime: {
							hours: "",
							minutes: "",
							time: { value: 0, label: "AM" },
						},
						checkOutTime: {
							hours: "",
							minutes: "",
							time: { value: 0, label: "AM" },
						},
						recordId: this.state.employee.value,
					});
				} else if (
					res.data.checkInTime === null &&
					res.data.checkOutTime === null &&
					res.data.recordId != null
				) {
					AlertPopups.successAlert.fire({
						text: `CheckIn and ChekOut are missing for current record`,
					});
					this.setState({
						checkInTime: {
							hours: "",
							minutes: "",
							time: { value: 0, label: "AM" },
						},
						checkOutTime: {
							hours: "",
							minutes: "",
							time: { value: 0, label: "AM" },
						},
						recordId: res.data.recordId,
					});
				} else if (res.data.checkOutTime === null) {
					const checkIn =
						res.data.checkInTime &&
						moment(res.data.checkInTime).format("hh:mm A");
					const checkInHour = checkIn.split(":")[0];
					const checkInMin = checkIn.substring(
						checkIn.indexOf(" "),
						3
					);
					const checkInA = checkIn.slice(-2);

					res.data.checkInTime &&
						this.setState({
							checkInTime:
								res.data.checkInTime != null
									? {
											hours: checkInHour,
											minutes: checkInMin,
											time: timeOptions.find((obj) => {
												return obj.label === checkInA;
											}),
									  }
									: //moment(res.data.checkInTime).format("HH:mm A")
									  "",
							checkOutTime: {
								hours: "",
								minutes: "",
								time: { value: 0, label: "AM" },
							},
							recordId: res.data.recordId,
						});
				} else {
					const checkIn =
						res.data.checkInTime &&
						moment(res.data.checkInTime).format("hh:mm A");
					const checkInHour = checkIn.split(":")[0];
					const checkInMin = checkIn.substring(
						checkIn.indexOf(" "),
						3
					);
					const checkInA = checkIn.slice(-2);
					const checkOut =
						res.data.checkOutTime &&
						moment(res.data.checkOutTime).format("hh:mm A");
					const checkOutHour = checkOut.split(":")[0];
					const checkOutMin = checkOut.substring(
						checkIn.indexOf(" "),
						3
					);
					const checkOutA = checkOut.slice(-2);

					this.setState({
						checkInTime:
							res.data.checkInTime != null
								? {
										hours: checkInHour,
										minutes: checkInMin,
										time: timeOptions.find((obj) => {
											return obj.label === checkInA;
										}),
								  }
								: //moment(res.data.checkInTime).format("HH:mm A")
								  "",
						checkOutTime:
							res.data.checkOutTime != null
								? {
										hours: checkOutHour,
										minutes: checkOutMin,
										time: timeOptions.find((obj) => {
											return obj.label === checkOutA;
										}),
								  }
								: //moment(res.data.checkInTime).format("HH:mm A")
								  "",
						recordId: res.data.recordId,
					});
				}
			});
	};

	handleReset() {
		this.setState({
			checkInTime: initialValues,
			checkOutTime: initialValues,
		});
	}
	handleCheckInTimeChange = (event, displayCode) => {
		//	handle StartTime
		if (displayCode === 1) {
			//startTime Hours
			this.setState({
				checkInTime: {
					hours: event.target.value,
					minutes: this.state.checkInTime.minutes,
					time: this.state.checkInTime.time,
				},
			});
		} else if (displayCode === 2) {
			//startTime Minutes
			this.setState({
				checkInTime: {
					hours: this.state.checkInTime.hours,
					minutes: event.target.value,
					time: this.state.checkInTime.time,
				},
			});
		} else {
			//startTime AM/PM
			this.setState({
				checkInTime: {
					hours: this.state.checkInTime.hours,
					minutes: this.state.checkInTime.minutes,
					time: event,
				},
			});
		}
	};
	handleCheckOutTimeChange = (event, displayCode) => {
		//	handle StartTime
		if (displayCode === 1) {
			//startTime Hours
			this.setState({
				checkOutTime: {
					hours: event.target.value,
					minutes: this.state.checkOutTime.minutes,
					time: this.state.checkOutTime.time,
				},
			});
		} else if (displayCode === 2) {
			//startTime Minutes
			this.setState({
				checkOutTime: {
					hours: this.state.checkOutTime.hours,
					minutes: event.target.value,
					time: this.state.checkOutTime.time,
				},
			});
		} else {
			//startTime AM/PM
			this.setState({
				checkOutTime: {
					hours: this.state.checkOutTime.hours,
					minutes: this.state.checkOutTime.minutes,
					time: event,
				},
			});
		}
	};

	render() {
		return (
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;
					return userDetails.empRole.includes("3") ? ( //authorization
						<div className="container-fluid pl-3 pr-3">
							<Header title="Employee Attendance Update" />
							{this.state.returnData ? (
								<div>
									<p>No Data Found</p>
								</div>
							) : (
								""
							)}
							<div>
								<Label className="attendanceUpdateLabel mb-0">
									Employee Attendance Update
								</Label>
							</div>
							<div className="spview-wrapper attendanceUpdate">
								<div className="bottomMargin col-md-12 mb-2  row">
									<div className="col-sm-12 p-0 titleClass">
										{this.state.employee.label}
										{this.state.weekDates.length !== 0 && (
											<>
												<span className="ml-3 vertical-line" />
												<span
													sm={5}
													className="col-md-4 col-sm-12 font-size-14 m-3 m-md-0 ml-auto  pr-0"
												>
													{moment(
														this.state.weekDates[0]
															.date
													).format(
														"dddd Do MMMM YYYY"
													) +
														" to " +
														moment(
															this.state
																.weekDates[6]
																.date
														).format(
															"dddd Do MMMM YYYY"
														)}
												</span>
												<span
													className="status-view ml-3"
													hidden={
														this.state.noDataFlag
													}
												>
													{this.state.status}
												</span>
											</>
										)}
									</div>
								</div>
								<Row className="ml-0">
									<div className="bottomMargin col-md-12 mb-3 row">
										<div className="col-md-3 col-sm-12 p-md-0 px-0">
											<CustomReactSelect
												placeholder="Select employee"
												options={this.employees()}
												name="employee"
												id="employee"
												bsSize="sm"
												styles={
													Timesheet_Variables.react_select_style
												}
												onChange={(value, event) =>
													this.handleChange(
														value,
														1,
														event
													)
												}
												paginationDropDown={true}
												value={this.state.employee}
											/>
										</div>
										<div className="col-md-3 col-sm-12 datePicker-col mb-2 mb-lg-0 mb-md-0 ml-5 mt-2 pl-2">
											<InputGroup className="inputGroup">
												<InputGroupAddon className="inputGroupAddon">
													<FontAwesomeIcon
														icon={faCalendarAlt}
														className="faIcon"
														onClick={
															this.openDatepicker
														}
														color="keppel"
														size="1x"
													/>
												</InputGroupAddon>
											</InputGroup>
											<DatePicker
												showYearDropdown
												showMonthDropdown
												dateFormatCalendar=" " //for title
												value={this.state.datePicker}
												name="datePicker"
												id="datePicker"
												bsSize="sm"
												selected={this.state.datePicker}
												onChange={(value, event) =>
													this.handleChange(
														value,
														2,
														event
													)
												}
												onChangeRaw={(e) => {
													e.preventDefault();
												}}
												autoComplete="off"
												className="form-control form-control-sm mb-sm-2 pb-1 attendanceDatePicker"
												dateFormat="dd/MM/yyyy"
												disabledKeyboardNavigation
												maxDate={new Date()}
												minDate={
													this.state.employee
														.joiningDate
												}
												ref={(c) =>
													(this._calendar = c)
												}
											/>
										</div>
										<div className="px-0 ml-5 pl-3">
											<Button
												className="Go-btn w-auto"
												onClick={() => {
													this.handleClick();
												}}
												style={{
													cursor: this.state
														.isDisabled
														? "not-allowed"
														: "pointer",
												}}
												disabled={this.state.isDisabled}
											>
												Get CheckIn CheckOut Time
											</Button>
										</div>
									</div>
								</Row>
								<Formik
									enableReinitialize={true}
									initialValues={{
										checkInTime: this.state.checkInTime,
										checkOutTime: this.state.checkOutTime,
									}}
									validationSchema={validate}
									validateOnChange={true}
									onSubmit={() => {
										this.handleSubmit();
									}}
								>
									{({ errors, handleSubmit }) => (
										<form
											onSubmit={handleSubmit}
											className="my-3"
										>
											<Row className="ml-0">
												<div className="bottomMargin col-md-12 mb-3 row">
													<div className="formInputContainer ml-3 mt-2">
														<Row className="d-flex align-items-center">
															<Col className="p-0 px-1">
																<Input
																	type="number"
																	name="hours"
																	min={0}
																	max={12}
																	placeholder="Hr"
																	autoComplete="off"
																	//className={`startTimeInput formValueInput`}
																	value={
																		this
																			.state
																			.checkInTime
																			.hours
																	}
																	className={`startTimeInput formValueInput${
																		errors.checkInTime
																			? errors
																					.checkInTime
																					.hours
																				? "invalid"
																				: ""
																			: ""
																	}`}
																	onChange={(
																		event
																	) => {
																		//limits to 2 digit
																		if (
																			event
																				.target
																				.value
																				.length ===
																			3
																		)
																			return false;
																		else
																			this.handleCheckInTimeChange(
																				event,
																				1
																			);
																	}}
																/>
															</Col>
															<span className="colon">
																:
															</span>
															<Col className="p-0 px-1">
																<Input
																	type="number"
																	name="minutes"
																	min={0}
																	max={60}
																	placeholder="Min"
																	autoComplete="off"
																	className={`startTimeInput formValueInput${
																		errors.checkInTime
																			? errors
																					.checkInTime
																					.minutes
																				? "invalid"
																				: ""
																			: ""
																	}`}
																	value={
																		this
																			.state
																			.checkInTime
																			.minutes
																	}
																	onChange={(
																		event
																	) => {
																		//limits to 2 digit
																		if (
																			event
																				.target
																				.value
																				.length ===
																			3
																		)
																			return false;
																		else
																			this.handleCheckInTimeChange(
																				event,
																				2
																			);
																	}}
																/>
															</Col>
															<Col className="pl-md-0 mr-5 col-5 col-md-5 col-lg-5">
																<CustomReactSelect
																	options={
																		timeOptions
																	}
																	value={
																		this
																			.state
																			.checkInTime
																			.time
																	}
																	className="timeSelectOptions"
																	onChange={(
																		event
																	) =>
																		this.handleCheckInTimeChange(
																			event,
																			3
																		)
																	}
																/>
															</Col>
														</Row>
													</div>
													<div className="formInputContainer ml-3 mt-2">
														<Row className="d-flex align-items-center">
															<Col className="p-0 px-1">
																<Input
																	type="number"
																	name="hours"
																	min={0}
																	max={12}
																	placeholder="Hr"
																	autoComplete="off"
																	className={`startTimeInput formValueInput${
																		errors.checkOutTime
																			? errors
																					.checkOutTime
																					.hours
																				? "invalid"
																				: ""
																			: ""
																	}`}
																	value={
																		this
																			.state
																			.checkOutTime
																			.hours
																	}
																	onChange={(
																		event
																	) => {
																		//limits to 2 digit
																		if (
																			event
																				.target
																				.value
																				.length ===
																			3
																		)
																			return false;
																		else
																			this.handleCheckOutTimeChange(
																				event,
																				1
																			);
																	}}
																/>
															</Col>
															<span className="colon">
																:
															</span>
															<Col className="p-0 px-1">
																<Input
																	type="number"
																	name="minutes"
																	min={0}
																	max={60}
																	placeholder="Min"
																	autoComplete="off"
																	className={`startTimeInput formValueInput${
																		errors.checkOutTime
																			? errors
																					.checkOutTime
																					.minutes
																				? "invalid"
																				: ""
																			: ""
																	}`}
																	value={
																		this
																			.state
																			.checkOutTime
																			.minutes
																	}
																	onChange={(
																		event
																	) => {
																		//limits to 2 digit
																		if (
																			event
																				.target
																				.value
																				.length ===
																			3
																		)
																			return false;
																		else
																			this.handleCheckOutTimeChange(
																				event,
																				2
																			);
																	}}
																/>
															</Col>
															<Col className="pl-md-0 col-5 col-md-5 col-lg-5">
																<CustomReactSelect
																	options={
																		timeOptions
																	}
																	value={
																		this
																			.state
																			.checkOutTime
																			.time
																	}
																	className="timeSelectOptions"
																	onChange={(
																		event
																	) =>
																		this.handleCheckOutTimeChange(
																			event,
																			3
																		)
																	}
																/>
															</Col>
														</Row>
													</div>
													<div className="px-0 ml-1">
														<Button
															type="submit"
															className="Go-btn ml-md-5 ml-lg-5"
															disabled={
																this.state
																	.checkOutTime ===
																" "
															}
														>
															Save
														</Button>
														<Button
															className="Go-btn ml-md-2 ml-lg-2"
															onClick={() => {
																this.handleReset();
															}}
														>
															Reset
														</Button>
													</div>
												</div>
											</Row>
										</form>
									)}
								</Formik>
							</div>
						</div>
					) : (
						<Redirect to="/MyDashboard" /> //redirection
					);
				}}
			</UserConsumer>
		);
	}
}
export default UpdateAttendance;
